import { render, staticRenderFns } from "./Chaperones.vue?vue&type=template&id=2b2286a4&scoped=true&"
import script from "./Chaperones.vue?vue&type=script&lang=js&"
export * from "./Chaperones.vue?vue&type=script&lang=js&"
import style0 from "./Chaperones.vue?vue&type=style&index=0&id=2b2286a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2286a4",
  null
  
)

export default component.exports